
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component({
  name: 'Dialog',
})
export default class Dialog extends Vue {
  @Prop({
    default: false,
    required: false,
  })
  visible!: boolean;
  @Prop({
    default: 'h5',
    required: false,
  })
  type!: string

  @Prop({
    default: 'bonusPool',
    required: false
  }) rule!: string
  @Emit('close')
  async close() {
    document.body.style.overflow = 'auto'
  }
}
